import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

let UiCCardInfoComponent = class UiCCardInfoComponent {
    constructor() {
        this.clickReload = new EventEmitter();
        this.iconName = 'eye-off-outline';
        this.isVisible = false;
        this.type = 'default';
        this.cardSliderOptions = {
            slidesPerView: 1,
            autoplay: true,
            speed: 600,
            simulateTouch: false,
        };
    }
    set typeCard(type) {
        this.type = type;
    }
    toggleVisibility() {
        this.isVisible = !this.isVisible;
        this.iconName = this.isVisible ? 'eye-outline' : 'eye-off-outline';
    }
    ngOnInit() { }
    reloadStatmentByClick() {
        this.clickReload.emit();
    }
};
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "title", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "content", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "imageUrl", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "imageAlt", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "reloadIcon", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "secundary", void 0);
__decorate([
    Output()
], UiCCardInfoComponent.prototype, "clickReload", void 0);
__decorate([
    Input('type')
], UiCCardInfoComponent.prototype, "typeCard", null);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "btnLabel", void 0);
__decorate([
    Input()
], UiCCardInfoComponent.prototype, "btnUrl", void 0);
UiCCardInfoComponent = __decorate([
    Component({
        selector: 'ui-c-card-info',
        template: "<ion-card class=\"d-flex flex-column justify-content-between card-info card-{{ type }}\">\n  <!-- conteudo do card -->\n  <ion-item class=\"flex-grow-0\" *ngIf=\"type !== 'slider'\" lines=\"none\">\n    <ion-label>{{ title }}</ion-label>\n    <!-- <ion-button *ngIf=\"type === 'default'\" (click)=\"toggleVisibility()\" fill=\"clear\" color=\"dark\">\n      <ion-icon class=\"icon-size\" [name]=\"iconName\"></ion-icon>\n    </ion-button> -->\n    <div class=\"d-flex\" *ngIf=\"type === 'default'\">\n      <ion-button *ngIf=\"type === 'default'\" (click)=\"toggleVisibility()\" fill=\"clear\" color=\"dark\" [disabled]=\"secundary === true\">\n        <ion-icon class=\"icon-size\" [name]=\"iconName\"></ion-icon>\n      </ion-button>\n      <ion-button [ngClass]=\"reloadIcon ? 'rotate' : ''\" [disabled]=\"secundary === true\"  *ngIf=\"type === 'default'\" (click)=\"reloadStatmentByClick()\" fill=\"clear\" color=\"dark\">\n        <ion-icon class=\"icon-size\" name=\"sync-sharp\"></ion-icon>\n      </ion-button>\n    </div>\n  </ion-item>\n\n  <div class=\"flex-grow-1\" [ngSwitch]=\"isVisible\">\n    <!-- ng-switch -->\n\n    <!-- conteudo default do card -->\n    <div [ngClass]=\"{ 'mt-3': type === 'default' }\" *ngSwitchCase=\"false\">\n      <ion-item *ngIf=\"type !== 'slider'\" lines=\"none\">\n        <ion-img [src]=\"imageUrl\" class=\"mx-auto ion-image\"> </ion-img>\n      </ion-item>\n      <ion-card-content class=\"text-center\">\n        <ng-container *ngIf=\"type === 'default' || type === 'button'\">\n          {{ content }}\n\n          <!-- botao do card -->\n          <ng-container *ngIf=\"type === 'button'\">\n            <ion-button [routerLink]=\"[btnUrl]\" class=\"mt-2 ui-c-card-info-btn\" expand=\"full\" shape=\"round\">\n              {{ btnLabel }}\n            </ion-button>\n          </ng-container>\n        </ng-container>\n\n        <!-- caso o tipo do card seja slider -->\n        <ng-container *ngIf=\"type === 'slider'\">\n          <ion-slides [options]=\"cardSliderOptions\" pager=\"false\">\n            <ng-content select=\"[card-slider]\"></ng-content>\n          </ion-slides>\n        </ng-container>\n      </ion-card-content>\n    </div>\n\n    <!-- conteudo escondido -->\n    <div *ngSwitchCase=\"true\">\n      <ion-card-content [ngClass]=\"{ 'pl-1': type === 'default', 'py-0': type === 'default' }\">\n        <ng-content select=\"[card-content]\"></ng-content>\n      </ion-card-content>\n    </div>\n  </div>\n  <!-- fim ng-switch -->\n</ion-card>\n",
        styles: [""]
    })
], UiCCardInfoComponent);

let UiCCardInfoModule = class UiCCardInfoModule {
};
UiCCardInfoModule = __decorate([
    NgModule({
        declarations: [UiCCardInfoComponent],
        imports: [IonicModule, RouterModule, CommonModule, ReactiveFormsModule, AngularSvgIconModule.forRoot()],
        exports: [UiCCardInfoComponent],
    })
], UiCCardInfoModule);

/*
 * Public API Surface of ui-c-card-info
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCCardInfoComponent, UiCCardInfoModule };
//# sourceMappingURL=wlp-ui-c-card-info.js.map
